export const fetchStockAvailability = async (branchNumber, productNumbers) => {
    if (productNumbers && productNumbers.length > 0) {
        return fetch(`/search/stock-availability/branches/${branchNumber}/products/inventory?productNumbers=${productNumbers.toString()}`, {
            method: "GET",
            credentials: "include"
        }).then((response) => {
            if (response.ok) {
                return response.json()
            } else {
                throw response.status
            }
        })
    }
    return null
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/stock-availability-pill/fetchStockAvailability.js